import { Button, Grid } from '@material-ui/core'
import ChevronLeftIcon from 'mdi-react/ChevronLeftIcon'

import i18n from '../../translations/i18n'
import { MuiClasses } from '../../types'

interface BackButtonProps {
  doStepBack: () => void
  currentStep: number
  classes: MuiClasses
  customStyle?: string
}

export const BackButton = ({
  doStepBack,
  currentStep,
  classes,
  customStyle
}: BackButtonProps) => {
  return (
    <Button
      disabled={currentStep === 0}
      onClick={doStepBack}
      style={{ width: '100%' }}
      className={`${classes.responsiveButton} ${customStyle}`}
    >
      <Grid container justify='center' alignItems='center'>
        <Grid item className={classes.leftFloatingIcon}>
          <ChevronLeftIcon color='#D8DCDF' />
        </Grid>
        <Grid>{i18n.t('general.back')}</Grid>
      </Grid>
    </Button>
  )
}
